<script setup lang="ts">
import { ref } from 'vue'

import { Participant } from '@collector/sportsapi-client'

import { getParticipantLogoUrl } from '../utils'

interface Props {
  participant: Participant
}

const props = defineProps<Props>()

const hasImageError = ref(false)

const initial = (props.participant.short_name || props.participant.name).charAt(
  0,
)
</script>

<template>
  <img
    v-if="!hasImageError"
    class="h-5 w-5"
    :src="getParticipantLogoUrl(participant)"
    @error="hasImageError = true"
  />
  <span
    v-else
    class="bg-neutral-dark-3/20 text-neutral-dark-2 text-2xs grid h-5 w-5 place-content-center rounded-full font-bold uppercase"
  >
    {{ initial }}
  </span>
</template>
